import script from "./ChangePasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePasswordModal.vue?vue&type=script&setup=true&lang=js"

import "./ChangePasswordModal.vue?vue&type=style&index=0&id=5ec7e011&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec7e011"]])

export default __exports__